import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SigningMethodPreferenceService {
    private preference = signal<'eSign' | 'wetsign' | null>(null);
    readonly currentPreference = this.preference.asReadonly();

    setPreference(method: 'eSign' | 'wetsign' | null) {
        this.preference.set(method);
    }
}
